import { FileActionsPopper } from './FileActionsPopper';

export default FileActionsPopper;
